// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","dots":"DotsLoader__dots--i2","dots-animation":"DotsLoader__dots-animation--je","dotsAnimation":"DotsLoader__dots-animation--je"};